import type { PortfolioButtonSize } from "../../../../domain/types/content";

/**
 * 포트폴리오 이미지가 받는 확장자.
 *
 * GIF 가 들어 있는 이유: 작업물 중에 움직이는 결과물이 있어서 애니메이션
 * GIF 를 그대로 올릴 수 있어야 한다. 백엔드가 포트폴리오 이미지에 한해
 * GIF 는 리사이즈(uploadImageWithMaxWidth)를 건너뛰고 원본을 올린다 —
 * 리사이즈를 거치면 ImageIO 재인코딩에서 첫 프레임만 남고 납작해진다.
 */
export const PORTFOLIO_IMAGE_ACCEPT = ".png,.jpg,.jpeg,.gif";

export const PORTFOLIO_BUTTON_SIZES: PortfolioButtonSize[] = [
  "SMALL",
  "MEDIUM",
  "LARGE",
];

export const PORTFOLIO_BUTTON_SIZE_LABELS: Record<
  PortfolioButtonSize,
  string
> = {
  SMALL: "작게",
  MEDIUM: "보통",
  LARGE: "크게",
};

/**
 * 버튼 URL 로 허용할 형태.
 *
 * `javascript:` 스킴을 막는 것이 핵심이다. 쇼핑몰이 이 값을 링크의 href 로
 * 그대로 출력하므로, 막지 않으면 관리자 화면이 저장한 값이 방문자 브라우저에서
 * 실행된다. 백엔드도 같은 검증을 하지만, 왕복 한 번 없이 어디가 잘못됐는지
 * 바로 짚어주려고 여기서 먼저 막는다.
 *
 * 상대 경로(`/shop/...`)를 허용하는 이유는 같은 쇼핑몰 안의 다른 페이지로
 * 보내는 버튼이 흔하기 때문이다. `//evil.com` 같은 프로토콜 상대 URL 은
 * 외부로 나가므로 상대 경로로 취급하지 않는다.
 */
export const isAllowedButtonUrl = (url: string): boolean => {
  const trimmed = url.trim();
  if (trimmed === "") return false;
  if (trimmed.startsWith("//")) return false;

  return (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("/")
  );
};

export const BUTTON_URL_HINT =
  "http:// 또는 https:// 로 시작하거나, 쇼핑몰 안의 경로면 / 로 시작해야 합니다.";

/**
 * 버튼 개수 상한. 백엔드가 같은 값으로 막으므로 UI 에서 먼저 잠근다 —
 * 10개를 채워놓고 저장 버튼을 눌러야 거절당하는 것보다, 추가 버튼이
 * 비활성화되는 편이 어디가 한계인지 분명하다.
 */
export const PORTFOLIO_BUTTON_MAX_COUNT = 10;
